import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import Emblem from "@/components/Emblem";
import api from "@/lib/api";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [state, setState] = useState("verifying"); // verifying | ok | error
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) { setState("error"); return; }
    api.post("/auth/verify-email", { token })
      .then(() => setState("ok"))
      .catch(() => setState("error"));
  }, [params]);

  return (
    <div className="min-h-screen flex justify-center bg-[var(--rsp-bg)]">
      <div className="w-full max-w-[440px] px-6 flex flex-col items-center text-center pt-20 pb-12" data-testid="verify-email-page">
        <Emblem size={120} />
        {state === "verifying" && (
          <>
            <Loader2 size={40} className="gold animate-spin mt-8 mb-3" />
            <h1 className="heading gold" style={{ fontSize: "1.9rem" }}>Verifying…</h1>
            <p className="text-[var(--rsp-gray)] text-sm mt-2">Confirming your email address.</p>
          </>
        )}
        {state === "ok" && (
          <>
            <CheckCircle2 size={48} className="gold mt-8 mb-3" data-testid="verify-ok" />
            <h1 className="heading gold" style={{ fontSize: "1.9rem" }}>Email verified</h1>
            <p className="text-[var(--rsp-gray)] text-sm mt-2">Your account is activated. You can now sign in.</p>
            <Link to="/login" className="btn-gold w-full py-3 mt-6 flex items-center justify-center gap-2" data-testid="verify-goto-login">Sign In</Link>
          </>
        )}
        {state === "error" && (
          <>
            <XCircle size={48} className="text-red-400 mt-8 mb-3" data-testid="verify-error" />
            <h1 className="heading" style={{ fontSize: "1.9rem" }}>Link invalid or expired</h1>
            <p className="text-[var(--rsp-gray)] text-sm mt-2">This verification link is invalid or has expired. Request a new one from the sign-in screen.</p>
            <Link to="/login" className="btn-gold w-full py-3 mt-6 flex items-center justify-center gap-2" data-testid="verify-back-login">Back to Sign In</Link>
          </>
        )}
      </div>
    </div>
  );
}
